'use strict';

var fitt = require('fitt'),
utils = require('./utils.js');

/**
                                * Resolve or reject a Promise based on response status.
                                *
                                * @param {Function} resolve - A function that resolves the promise.
                                * @param {Function} reject - A function that rejects the promise.
                                * @param {Object} response - The response.
                                */
function settle(resolve, reject, response) {
	var validateResponse = response.config.validateResponse;
	// Note: status is not exposed by XDomainRequest
	if (!response.status || !validateResponse || validateResponse(response)) {
		resolve(response);
	} else {
		reject(utils.createError(
		'HTTP request failed with status code ' + response.status + ': ' + response.url,
		response.url,
		response.config,
		null,
		response.status,
		response.data));

	}
}

if (typeof module !== fitt.TYPE_UNDEF) {
	module.exports = settle;
}


//////////////////
// WEBPACK FOOTER
// ../~/espn-fitt/es5/fitt-http/core/settle.js
// module id = 600
// module chunks = 0